// extracted by mini-css-extract-plugin
export default {"background":"XCiQHg","container":"afiZLA","cards":"tfCiE0","sameSizeColumns":"bgaAWE","loadMoreWrapper":"USInog"};